import Layout, { Wrapper } from "components/general/Layout";
import React, { Component } from "react";
import { helloWidgetApiBase, helloWidgetUrl } from "environment";

import CompanyLogo from "components/general/CompanyLogo";
import DepartmentSelect from "components/jobs/DepartmentSelect";
import EnvironmentIndicator from "components/dev/EnvironmentIndicator";
import Header from "components/jobs/Header";
import { Helmet } from "react-helmet";
import JobPageRow from "components/jobs/JobPageRow";
import OfficeSelect from "components/jobs/OfficeSelect";
import PillButton from "components/general/PillButton";
import SearchInput from "components/general/SearchInput";
import Toast from "components/general/Toast";
import { analytics } from "utils/analytics";
import { appEndpoint } from "environment";
import { bindActionCreators } from "redux";
import { compose } from "redux";
import { connect } from "react-redux";
import iconClose from "images/ic_close.png";
import iconFilter from "images/ic_filter.png";
import imageMadeWithPuck from "images/made_with_puck.svg";
import { loadPublicJobBoard } from "slices/jobs";
import { matchJobsToSearchTerm } from "utils/helpers";
import queryString from "query-string";
import styled from "styled-components";
import theme from "styles/theme";
import { toast } from "react-toastify";
import { unwrapResult } from "@reduxjs/toolkit";
import withRouter from "hocs/withRouter";
import { withTranslation } from "react-i18next";

const PageTitleContainer = styled.div`
  text-align: center;
  padding: ${theme.spacing.unit * 2}px 0 ${theme.spacing.unit * 8}px;
  color: #2c2c2c;

  ${theme.media.phone`
    padding: ${theme.spacing.unit * 1}px 0 ${theme.spacing.unit * 4}px;
  `}
`;

const PageTitleEmphasized = styled.div`
  font-family: degular, sans-serif;
  font-style: normal;
  font-weight: bold;
  font-size: 64px;
  line-height: 90%;

  ${theme.media.phone`
    font-size: 32px;
  `}
`;

const PageTitle = styled.div`
  font-family: "Degular";
  font-style: normal;
  font-weight: normal;
  font-size: 64px;
  line-height: 90%;

  ${theme.media.phone`
    font-size: 32px;
  `}
`;

const FiltersContainer = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  margin-bottom: ${theme.spacing.unit * 2}px;
`;

const Filters = styled.div`
  display: flex;
  width: 100%;
  margin-bottom: ${theme.spacing.unit * 2}px;
  flex-direction: column;
  row-gap: ${theme.spacing.unit * 2}px;

  ${theme.media.phone`
    row-gap: ${theme.spacing.unit * 1}px;
    margin-bottom: ${theme.spacing.unit * 1}px;
  `}
`;

const SearchContainer = styled.div`
  flex: 2;

  ${theme.media.phone`
    flex: 1;
  `}
`;

const MobileMoreFiltersToggle = styled.div`
  display: none;

  ${theme.media.phone`
    display: flex;
    justify-content: center;
  `}
`;

const MoreFilters = styled.div`
  display: flex;
  column-gap: ${theme.spacing.unit * 2}px;
  flex: 3;

  ${theme.media.phone`
    display: ${(props) => (props.$areFiltersVisible ? "flex" : "none")};
    flex-direction: column;
    row-gap: ${theme.spacing.unit * 1}px;
  `}
`;

const SelectContainer = styled.div`
  flex: 1;
`;

const FilterPills = styled.div`
  display: flex;
  flex-wrap: wrap;
  row-gap: 4px;
  column-gap: 4px;
  margin-bottom: ${theme.spacing.unit * 2}px;

  ${theme.media.phone`
    margin-bottom: ${theme.spacing.unit * 1}px;
  `}
`;

const Department = styled.div`
  padding: ${theme.spacing.unit * 2}px 0 ${theme.spacing.unit * 3}px;

  font-family: degular, sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 30px;
  color: #2c2c2c;
`;

const FilteredResultsContainer = styled.div`
  padding-top: ${theme.spacing.unit * 4}px;
`;

const NumResultsText = styled.div`
  padding-bottom: ${theme.spacing.unit * 1}px;
  padding-left: ${theme.spacing.unit * 2}px;

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 120%;
`;

const NoResultsContainer = styled.div`
  padding: ${theme.spacing.unit * 4}px 0 ${theme.spacing.unit * 4}px;
  text-align: center;
`;

const NoResultsText = styled.div`
  padding-bottom: ${theme.spacing.unit * 2}px;

  font-family: degular, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 123%;
  color: #2c2c2c;
`;

const MadeWithPuckContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 100px;
`;

const StyledJobPageRow = styled(JobPageRow)`
  margin: 4px 0;
`;

export class JobBoardPublic extends Component {
  constructor(props) {
    super(props);

    this.state = {
      jobBoard: null,
      officePermalink: null,
      departmentPermalink: null,
      searchTerm: "",
      areFiltersVisible: false,
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);

    analytics.page();

    this.loadJobBoard();
  }

  componentWillUnmount() {
    if (window.puckHelloWidget) {
      window.puckHelloWidget.hide();
    }
  }

  loadJobBoard = async () => {
    const { dispatch, params } = this.props;
    const { jobBoardPermalink } = params;

    const resultAction = await dispatch(loadPublicJobBoard(jobBoardPermalink));
    if (loadPublicJobBoard.fulfilled.match(resultAction)) {
      const jobBoard = unwrapResult(resultAction);

      this.setState(
        {
          jobBoard,
        },
        () => this.initJobBoard()
      );
    }
  };

  initJobBoard() {
    const { jobBoard } = this.state;
    const { location } = this.props;

    const queryParams = queryString.parse(location.search);

    if (queryParams.notFound) {
      toast.warning(<Toast title={"This job is no longer available"} />);
      const newParams = new URLSearchParams(location.search);
      newParams.delete("notFound");
      this.props.navigate(location.pathname, {
        search: newParams.toString(),
      });
    }

    analytics.track("Visited JobBoard Public", {
      permalink: jobBoard.permalink,
      employer: jobBoard.employerProfile.name,
      employerPermalink: jobBoard.employerProfile.permalink,
      platform: jobBoard.atsSourcePlatform,
    });

    // Figure out the office permalink from the office name in the url
    let officePermalink = null;
    if (queryParams.location) {
      const office = jobBoard.flatOffices.find(
        (o) => o.name === queryParams.location
      );
      if (office) {
        officePermalink = office.permalink;
      } else {
        const officeChild = jobBoard.flatOffices
          .map((o) => o.flatChildren)
          .flat()
          .find((oc) => oc.name === queryParams.location);
        if (officeChild) {
          officePermalink = officeChild.permalink;
        }
      }
    }
    if (queryParams.locationId) {
      officePermalink = queryParams.locationId;
    }

    // Figure out the department permalink from the department name in the url
    let departmentPermalink = null;
    if (queryParams.department) {
      const department = jobBoard.flatDepartments.find(
        (d) => d.name === queryParams.department
      );
      if (department) {
        departmentPermalink = department.permalink;
      } else {
        const departmentChild = jobBoard.flatDepartments
          .map((d) => d.flatChildren)
          .flat()
          .find((dc) => dc.name === queryParams.department);
        if (departmentChild) {
          departmentPermalink = departmentChild.permalink;
        }
      }
    }
    if (queryParams.departmentId) {
      departmentPermalink = queryParams.departmentId;
    }

    // Also initialize defaults if in the url
    this.setState({
      officePermalink,
      departmentPermalink,
    });
  }

  updateQueryString = () => {
    const { officePermalink, departmentPermalink } = this.state;
    const { location, navigate } = this.props;

    const search = new URLSearchParams(location.search);
    search.delete("location");
    search.delete("locationId");
    search.delete("department");
    search.delete("departmentId");
    if (officePermalink) {
      search.set("locationId", officePermalink);
    }
    if (departmentPermalink) {
      search.set("departmentId", departmentPermalink);
    }
    navigate({ search: search.toString() }, { replace: true });
  };

  handleApplyClick = (job, url) => (e) => {
    const { jobBoard } = this.state;

    e.preventDefault();

    analytics.track(
      "JobBoard Public Clicked Apply",
      {
        permalink: jobBoard.permalink,
        jobPermalink: job.permalink,
        jobAtsSourceId: job.atsSourceId,
        employer: jobBoard.employerProfile.name,
        employerPermalink: jobBoard.employerProfile.permalink,
        platform: jobBoard.atsSourcePlatform,
      },
      {},
      () => {
        const newUrl = new URL(url);
        if (!appEndpoint.includes(newUrl.hostname)) {
          window.open(url, "_blank") || window.location.assign(url);
        } else {
          this.props.navigate(newUrl.pathname + newUrl.search);
        }
      }
    );
  };

  handleSelect = (field) => (option) => {
    let value = option.value;
    if (option.value === "All") {
      value = null;
    }
    this.setState(
      {
        [field]: value,
      },
      () => {
        this.updateQueryString();
      }
    );
  };

  removeSearchTermFilterClick = () => {
    this.setState({
      searchTerm: "",
    });
  };

  removeOfficeFilterClick = () => {
    this.setState({
      officePermalink: null,
    });
  };

  removeDepartmentFilterClick = () => {
    this.setState({
      departmentPermalink: null,
    });
  };

  handleResetFiltersClick = () => {
    this.setState(
      {
        searchTerm: "",
        officePermalink: null,
        departmentPermalink: null,
      },
      () => {
        this.updateQueryString();
      }
    );
  };

  jobPageRow = (jobPage) => {
    const { jobBoard } = this.state;
    const { location } = this.props;

    let targetUrl = jobPage.publicUrl;

    // Pass along params that aren't set by this page
    const queryParams = queryString.parse(location.search);
    let jobPageParams = null;
    for (let key in queryParams) {
      if (key !== "location" && key !== "department" && key !== "notFound") {
        if (!jobPageParams) {
          jobPageParams = {};
        }
        jobPageParams[key] = queryParams[key];
      }
    }
    if (jobPageParams) {
      targetUrl += `?${queryString.stringify(jobPageParams)}`;
    }

    return (
      <StyledJobPageRow
        key={jobPage.permalink}
        href={targetUrl}
        jobPage={jobPage}
        onClick={this.handleApplyClick(jobPage, targetUrl)}
        button={
          <PillButton
            isSmall
            isInactive
            isBrandedPrimary
            brandingData={jobBoard.employerProfile.brandingData}
          >
            Learn more
          </PillButton>
        }
      />
    );
  };

  handleSearchChange = (e) => {
    this.setState({
      searchTerm: e.target.value,
    });
  };

  handleMadeWithPuckClick = (e) => {
    const { jobBoard } = this.state;

    e.preventDefault();

    analytics.track(
      "JobBoard Public Clicked Made With Puck",
      {
        permalink: jobBoard.permalink,
        employer: jobBoard.employerProfile.name,
        employerPermalink: jobBoard.employerProfile.permalink,
        platform: jobBoard.atsSourcePlatform,
        location: "footer",
      },
      {},
      () => {
        window.location.href = "https://www.careerpuck.com";
      }
    );
  };

  handleMoreFiltersToggleClick = () => {
    const { areFiltersVisible } = this.state;

    this.setState({
      areFiltersVisible: !areFiltersVisible,
    });
  };

  render() {
    const {
      jobBoard,
      officePermalink,
      departmentPermalink,
      searchTerm,
      areFiltersVisible,
    } = this.state;
    const { t } = this.props;

    // If any filters are active, return the list of jobs without groupings
    let isFiltered = false;
    let filteredJobs = null;
    if (jobBoard) {
      filteredJobs = jobBoard.jobs;

      if (officePermalink) {
        isFiltered = true;
        filteredJobs = filteredJobs.filter((job) => {
          let isInOffice = false;
          if (job.topOffice?.permalink === officePermalink) {
            return true;
          } else {
            for (const _office of job.offices) {
              if (_office.permalink === officePermalink) {
                isInOffice = true;
                break;
              }
            }
          }
          return isInOffice;
        });
      }
      if (departmentPermalink) {
        isFiltered = true;
        filteredJobs = filteredJobs.filter((job) => {
          let isInDepartment = false;
          if (job.topDepartment?.permalink === departmentPermalink) {
            return true;
          } else {
            for (const _department of job.departments) {
              if (_department.permalink === departmentPermalink) {
                isInDepartment = true;
                break;
              }
            }
          }
          return isInDepartment;
        });
      }

      const jobsMatch = matchJobsToSearchTerm(searchTerm, filteredJobs);
      if (jobsMatch) {
        filteredJobs = jobsMatch;
        isFiltered = true;
      }

      filteredJobs.sort((jobA, jobB) => jobA.title.localeCompare(jobB.title));
    }

    let officeFilterName = "";
    if (officePermalink) {
      for (const _office of jobBoard.flatOffices) {
        if (_office.permalink === officePermalink) {
          officeFilterName = _office.name;
        }
        for (const officeChild of _office.flatChildren) {
          if (officeChild.permalink === officePermalink) {
            officeFilterName = officeChild.name;
          }
        }
      }
    }

    let departmentFilterName = "";
    if (departmentPermalink) {
      for (const _department of jobBoard.flatDepartments) {
        if (_department.permalink === departmentPermalink) {
          departmentFilterName = _department.name;
        }
        for (const departmentChild of _department.flatChildren) {
          if (departmentChild.permalink === departmentPermalink) {
            departmentFilterName = departmentChild.name;
          }
        }
      }
    }

    return (
      <>
        <Helmet
          bodyAttributes={{ style: `background: ${theme.colors.white};` }}
        >
          {jobBoard && jobBoard.helloWidgetJobBoardVisible && (
            <script>
              {`
                function onPuckHelloWidgetScriptReady() {
                  window.puckHelloWidget.loadWidget({
                    jobBoardPermalink: "${jobBoard.permalink}",
                    employerName: "${jobBoard.employerProfile.name}",
                    ${
                      helloWidgetApiBase
                        ? `apiBase: "${helloWidgetApiBase}"`
                        : ""
                    }
                  });
                }
                var script = document.createElement('script');
                document.head.appendChild(script);
                script.onload = onPuckHelloWidgetScriptReady;
                script.src = "${helloWidgetUrl}";
                script.async = false;
              `}
            </script>
          )}
        </Helmet>
        {jobBoard && (
          <Layout>
            <EnvironmentIndicator />
            <Header
              isShadowHidden={true}
              left={
                <CompanyLogo
                  logoUrl={jobBoard.employerProfile.brandingData.logoUrl}
                  employerProfile={jobBoard.employerProfile}
                  alt={`${jobBoard.employerProfile.name} logo`}
                />
              }
            />
            <Wrapper
              $maxWidth={928}
              $marginBottom={200}
              $paddingMobile={theme.spacing.unit * 1}
            >
              <PageTitleContainer>
                <PageTitleEmphasized>{t("Join the team")}</PageTitleEmphasized>
                <PageTitle>{`at ${jobBoard.employerProfile.name}`}</PageTitle>
              </PageTitleContainer>
              <FiltersContainer>
                <Filters>
                  <SearchContainer>
                    <SearchInput
                      placeholder={t("Search")}
                      value={searchTerm}
                      onChange={this.handleSearchChange}
                    />
                  </SearchContainer>
                  <MoreFilters $areFiltersVisible={areFiltersVisible}>
                    <SelectContainer>
                      <OfficeSelect
                        jobBoard={jobBoard}
                        officePermalink={officePermalink}
                        onChange={this.handleSelect("officePermalink")}
                      />
                    </SelectContainer>
                    <SelectContainer>
                      <DepartmentSelect
                        jobBoard={jobBoard}
                        departmentPermalink={departmentPermalink}
                        onChange={this.handleSelect("departmentPermalink")}
                      />
                    </SelectContainer>
                  </MoreFilters>
                  <MobileMoreFiltersToggle
                    $areFiltersVisible={areFiltersVisible}
                  >
                    <PillButton
                      isSmall
                      isGhost
                      icon={iconFilter}
                      onClick={this.handleMoreFiltersToggleClick}
                    >
                      Show {areFiltersVisible ? "less" : "more"} filters
                    </PillButton>
                  </MobileMoreFiltersToggle>
                </Filters>
              </FiltersContainer>
              {searchTerm || officePermalink || departmentPermalink ? (
                <FilterPills>
                  {searchTerm && (
                    <PillButton
                      isSmall
                      isSecondary
                      icon={iconClose}
                      onClick={this.removeSearchTermFilterClick}
                    >
                      {searchTerm}
                    </PillButton>
                  )}
                  {officePermalink && (
                    <PillButton
                      isSmall
                      isSecondary
                      icon={iconClose}
                      onClick={this.removeOfficeFilterClick}
                    >
                      {officeFilterName}
                    </PillButton>
                  )}
                  {departmentPermalink && (
                    <PillButton
                      isSmall
                      isSecondary
                      icon={iconClose}
                      onClick={this.removeDepartmentFilterClick}
                    >
                      {departmentFilterName}
                    </PillButton>
                  )}
                </FilterPills>
              ) : null}
              {isFiltered ? (
                <>
                  {filteredJobs.length > 0 ? (
                    <FilteredResultsContainer>
                      <NumResultsText role="status">{`${filteredJobs.length} job postings found`}</NumResultsText>
                      {filteredJobs.map((job) => this.jobPageRow(job))}
                    </FilteredResultsContainer>
                  ) : (
                    <NoResultsContainer>
                      <NoResultsText role="status">
                        No job postings match these filters
                      </NoResultsText>
                      <PillButton
                        isGhost
                        onClick={this.handleResetFiltersClick}
                      >
                        Go back to all job postings
                      </PillButton>
                    </NoResultsContainer>
                  )}
                </>
              ) : (
                <>
                  {jobBoard.flatDepartments.map((department) => {
                    const departmentJobs = jobBoard.jobs
                      .filter((job) => {
                        if (
                          job.departments
                            .map((d) => d.name)
                            .includes(department.name)
                        )
                          return true;
                        return !!job.departments.find((d) =>
                          department.flatChildren
                            .map((dd) => dd.permalink)
                            .includes(d.permalink)
                        );
                      })
                      .sort((jobA, jobB) =>
                        jobA.title.localeCompare(jobB.title)
                      );
                    if (departmentJobs.length === 0) return null;
                    return (
                      <div key={department.permalink}>
                        <Department>{department.name}</Department>
                        <div>
                          {departmentJobs.map((job) => this.jobPageRow(job))}
                        </div>
                      </div>
                    );
                  })}
                </>
              )}
              <MadeWithPuckContainer>
                <a
                  href="https://www.careerpuck.com"
                  onClick={this.handleMadeWithPuckClick}
                >
                  <img
                    src={imageMadeWithPuck}
                    alt="Made with puck"
                    width={182.5}
                    height={24.18}
                  />
                </a>
              </MadeWithPuckContainer>
            </Wrapper>
          </Layout>
        )}
      </>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    dispatch,
    ...bindActionCreators(
      {
        loadPublicJobBoard,
      },
      dispatch
    ),
  };
}

const enhance = compose(
  withRouter,
  connect(null, mapDispatchToProps),
  withTranslation()
);

export default enhance(JobBoardPublic);
